import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { OrganizationListScreen, OrganizationScreen } from '../screens';
import { Icon } from '@ui-kitten/components';
import { getMenuAction } from './shared/sidebar.menu';


const Stack = createStackNavigator();

export const OrganizationStack = () => (
    <Stack.Navigator>
        <Stack.Screen
            name='All'
            component={OrganizationListScreen}
            options={{ title: 'Groups', ...getMenuAction(true) }}
        />
        <Stack.Screen
            name='Group'
            component={OrganizationScreen}
            options={{ title: 'Group' }}
        />
    </Stack.Navigator>
);



const MenuIcon = (style: any) => (
    <Icon {...style} name='menu-outline' height={30} width={30} />
);